import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../../services/http.service";
import { apiPageLimit } from "../../../../constants/common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

const GENERATE_REPORT = `/real-state/user/report`;
const NON_REAL_REPORT = `/non-real-state/user/report`;


export const generateReport = createAsyncThunk(
  "generateReport",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${GENERATE_REPORT}`, values);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to generate report. Please try again.");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getReportList = createAsyncThunk(
  "getReportList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, owner_uuid = "", timezone = "" } = values;

      const response = await http.get(`${GENERATE_REPORT}?page=${page}&limit=${limit}&owner_uuid=${owner_uuid}&timezone=${timezone}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const generateNonRealReport = createAsyncThunk(
  "generateNonRealReport",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${NON_REAL_REPORT}`, values);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to generate report. Please try again.");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getNonRealReportList = createAsyncThunk(
  "getNonRealReportList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, timezone = "" } = values;

      const response = await http.get(`${NON_REAL_REPORT}?page=${page}&limit=${limit}&timezone=${timezone}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
